import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {GameThemeFilterDefinition} from "../filters-definitions/theme/game-theme.filter-definition";
import {CategoryDefinitionId} from "./filter-category-definition.interface";
import {Check} from "@sparkware/app-utils";

export class GameThemeFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'themes';
    }

    get title(): string{
        return this.services.translation.translate('THEME');
    }

    get hasItsOwnFiltersOrder(): boolean {
        return !Check.isEmpty(this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredThemeFilters);
    }

    private _getPreferredThemeFilters(): GameThemeFilterDefinition[] {
        return [
            new GameThemeFilterDefinition("theme_adventure", this.services, this.services.translation.translate("Adventure"), [ 1, 20, 24, 27, 40, 42, 49, 59, 65, 68, 70, 71, 86, 89]),
            new GameThemeFilterDefinition("theme_ancient_civilization", this.services, this.services.translation.translate("Ancient Civilization"), [ 2, 44, 45, 57, 6, 80, 82, 88]),
            new GameThemeFilterDefinition("theme_arabic", this.services, this.services.translation.translate("Arabic"), [ 58]),
            new GameThemeFilterDefinition("theme_asian", this.services, this.services.translation.translate("Asian"), [ 5]),
            new GameThemeFilterDefinition("theme_classic_style", this.services, this.services.translation.translate("Classic Style"), [ 17, 21, 4]),
            new GameThemeFilterDefinition("theme_comics_and_cartoons", this.services, this.services.translation.translate("Comics and Cartoons"), [ 16, 22, 39]),
            new GameThemeFilterDefinition("theme_diamonds_and_gems", this.services, this.services.translation.translate("Diamonds and Gems"), [ 26, 50]),
            new GameThemeFilterDefinition("theme_egyptian", this.services, this.services.translation.translate("Egyptian"), [ 30]),
            new GameThemeFilterDefinition("theme_fantasy_and_folklore", this.services, this.services.translation.translate("Fantasy and Folklore"), [ 28, 31, 33, 34, 36, 46, 56]),
            new GameThemeFilterDefinition("theme_farm_and_pets", this.services, this.services.translation.translate("Farm and Pets"), [ 35]),
            new GameThemeFilterDefinition("theme_fish", this.services, this.services.translation.translate("Fish"), [ 77, 87]),
            new GameThemeFilterDefinition("theme_fruit_and_candy", this.services, this.services.translation.translate("Fruit and Candy"), [ 12, 13, 38]),
            new GameThemeFilterDefinition("theme_greek_mythology", this.services, this.services.translation.translate("Greek Mythology"), [ 63]),
            new GameThemeFilterDefinition("theme_irish", this.services, this.services.translation.translate("Irish"), [ 19, 48]),
            new GameThemeFilterDefinition("theme_money_and_leisure", this.services, this.services.translation.translate("Money and Leisure"), [ 15, 18, 32, 37, 41, 53, 60, 73, 79]),
            new GameThemeFilterDefinition("theme_movies_and_music", this.services, this.services.translation.translate("Movies and Music"), [ 10, 61, 62, 8]),
            new GameThemeFilterDefinition("theme_seasonal", this.services, this.services.translation.translate("Seasonal"), [ 29, 43, 78, 91]),
            new GameThemeFilterDefinition("theme_space_and_sci-fi", this.services, this.services.translation.translate("Space and Sci-fi"), [ 72, 75, 81, 84, 85]),
            new GameThemeFilterDefinition("theme_wildlife", this.services, this.services.translation.translate("Wildlife"), [ 11, 3, 51, 66, 67, 90, 92]),
        ];
    }


    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        const preferredThemeFilters = this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredThemeFilters;
        if(Check.isEmpty(preferredThemeFilters)) {
            return this._getPreferredThemeFilters();
        }

        const themesDictionary = this._getPreferredThemeFilters().toDictionary(f => f.id);

        const result: IGameFilterDefinition[] = [];
        for(let filterId of preferredThemeFilters) {
            const filter = themesDictionary[filterId];
            if(filter) {
                result.push(filter);
            } else {
                this.services.logger.error(`There is no filter definition for filter with ID ${filterId}`);
            }
        }

        return result;

    }
}